var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuestionBubble = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9964 3.06622e-07C19.7029 0.000649198 15.4883 1.15302 11.7918 3.33697C8.09537 5.52093 5.05243 8.65649 2.98028 12.4168C0.908122 16.177 -0.117382 20.4243 0.010681 24.7159C0.138744 29.0074 1.41568 33.186 3.70837 36.816L0.796375 47.733L11.3914 44.421C14.5493 46.3709 18.1165 47.5617 21.8124 47.9001C25.5084 48.2384 29.2324 47.7149 32.6919 46.3708C36.1514 45.0267 39.252 42.8986 41.75 40.1538C44.2481 37.4089 46.0755 34.1221 47.0887 30.5516C48.1018 26.9812 48.2731 23.2244 47.5891 19.5766C46.905 15.9288 45.3843 12.4893 43.1464 9.52848C40.9085 6.56768 38.0144 4.16625 34.6916 2.51291C31.3688 0.85958 27.7078 -0.000592908 23.9964 3.06622e-07ZM23.9964 45C19.6448 44.9263 15.4087 43.5883 11.8044 41.149C11.4574 41.256 4.67338 43.378 5.09737 43.249C5.19737 42.892 6.83637 36.724 6.94537 36.321C4.323 32.7533 2.93649 28.4274 2.99638 24C2.99638 19.8466 4.228 15.7865 6.53551 12.333C8.84302 8.87959 12.1228 6.18797 15.96 4.59853C19.7973 3.00909 24.0197 2.59322 28.0933 3.40351C32.1669 4.2138 35.9087 6.21385 38.8456 9.15076C41.7825 12.0877 43.7826 15.8295 44.5929 19.9031C45.4032 23.9767 44.9873 28.1991 43.3978 32.0364C41.8084 35.8736 39.1168 39.1534 35.6633 41.4609C32.2099 43.7684 28.1498 45 23.9964 45Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuestionBubble);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/question-bubble.65be4302b99ef0068eedb031a02bf4fe.svg";